import Axios from "axios";
// import { useAuthStore } from "./stores/auth.store";
// import { getToken } from "./utils/authorization";
// import jwt_decode from 'jwt-decode';

// Axios.defaults.baseURL = import.meta.env.VITE_BASE_API;
Axios.defaults.baseURL = process.env.VUE_APP_BASE_API_ANCS || 'http://localhost:8084/'

Axios.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("TOKEN");
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);